export const cu = {
  // 기존 차세대
  jsonExpr2PropertyObject: <T>(jsonExpr: string): Property<T> => {
    const jsonObj = jsonExpr ? JSON.parse(jsonExpr) : {};
    return {name: jsonObj.name, value: jsonObj.value as T};
  },
  isEmpty: (tobj: any) => {
    if (!tobj) {
      return true;
    } else if (Array.isArray(tobj)) {
      return tobj.length == 0;
    } else if (typeof(tobj) == 'string') {
      return tobj.length == 0;
    } else if (tobj.value !== undefined) {
      if (!tobj.value) {
        return true;
      } else if (Array.isArray(tobj.value)) {
        return tobj.value.length == 0;
      } else if (typeof(tobj.value) == 'string') {
        return tobj.value.length == 0;
      }
    }
    return false;
  },
  isNotEmpty: (tobj: any) => {
    return !cu.isEmpty(tobj);
  },
  actualValue: <T>(dynamicValue:DynamicValue<T>): T|undefined => dynamicValue == null ? undefined : typeof dynamicValue == 'function' ? (dynamicValue as () => T)() : unref(dynamicValue),

  getFirst: (arr: any, defaultValue?: any, allocate?: boolean) => {
    let rv;
    if (arr) {
      if (Array.isArray(arr)) {
        if (arr.length == 0) {
          if (allocate) {
            rv  = arr[0]  = defaultValue;
          }
        } else {
          rv  = arr[0];
        }
      } else {
        rv  = arr;
      }
    }
    if (rv === undefined) {
      return defaultValue;
    } else if (rv == null) {
      return defaultValue === undefined ? null : defaultValue;
    } else {
      return rv;
    }
  },
  lpad: (data: any, size: number, filler: string)  => {
    if (!data) {
      data  = '';
    }
    let rv  = '' + data;
    if (cu.isNotEmpty(filler)) {
      while(rv.length < size) {
        rv  = filler + rv;
      }
    }
    return rv;
  },
  rpad: (data: any, size: number, filler: string)  => {
    if (!data) {
      data  = '';
    }
    let rv  = '' + data;
    if (cu.isNotEmpty(filler)) {
      while(rv.length < size) {
        rv  = rv + filler;
      }
    }
    return rv;
  },
  copyProps: (from: any, to: any) => {
    for (const propKey in from) {
      to[propKey] = from[propKey];
    }
  },
  isOnProduct: () => {
    return !import.meta.dev;
  },
  makeQueryString: (data: any, prefix?: string) => {
    const makeParameter = (obj: any, prefix?: string): string => {
      if (obj == null) {
        return '';
      } else if (Array.isArray(obj)) {
        let parts  = [];
        for (let v of obj) {
          const part  = makeParameter(v, prefix);
          if (cu.isNotEmpty(part)) {
            parts.push(part);
          }
        }
        return parts.join('&');
      } else if (typeof(obj) == 'object') {
        let parts  = [];
        for (let key of Object.keys(obj)) {
          const part  = makeParameter(obj[key], prefix ? prefix + '.' + key : key);
          if (cu.isNotEmpty(part)) {
            parts.push(part);
          }
        }
        return parts.join('&');
      } else {
        return encodeURIComponent(prefix ? prefix : 'param') + '=' + encodeURIComponent(obj);
      }
    }
    return makeParameter(data, prefix);
  },
  promiseOf: <T>(result: T) => {
    return new Promise<T>((handleResult)=> handleResult(result));
  },
  path4device: (path: string, isMobile?: boolean) => {
    const paths = path.split('/');
    if (paths.length < 2) {
      return path;
    }
    if (paths[1] != '-device-' && paths[1] != 'pc' && paths[1] != 'mo') {
      return path;
    }
    if (isMobile === undefined) {
      const locpaths  = location.pathname.split('/');
      if (locpaths.length < 2) {
        paths[1]  = paths[1] == '-device-' ? 'pc' : paths[1];
      } else {
        paths[1]  = locpaths[1];
      }
    } else {
      paths[1]  = isMobile ? 'mo' : 'pc';
    }
    return paths.join('/');
  },
  // HCON 추가
  format: {
    // 메시지 파라미터 변환
    message: (msg: string, ...args: any[]): string => {
      return msg.replace(/{([A-Za-z0-9_]+)}/g, (_, key) => {
        console.log({ key, args });
        return args[Number(key)];
      });
    },
    convertToKey: (code: number) => {
      const convertedcode = String(code).slice(-4);
      return `ALT_HCON_${convertedcode}`;
    },
    // 전화번호 형식 변환 ('-' 형식 변환)
    phone: (target: string) => {
      if (!target) {
        return '';
      }
      if (target.indexOf('-') > -1 ) {
        return target;
      }
      const cleaned = target.replace(/\D/gi, '').slice(0, 11);
      if (cleaned.length > 10) {
        return cleaned.replace(/(02|\d{3})(\d{4})(\d{0,4})/, '$1-$2-$3');
      } else if (cleaned.length > 7) {
        return cleaned.replace(/(02|\d{3})(\d{3})(\d{0,4})/, '$1-$2-$3');
      } else if (cleaned.length > 3) {
        return cleaned.replace(/(02|\d{3})(\d{3})/, '$1-$2');
      } else {
        return cleaned;
      }
    },
    // 날짜 형식 변환
    date: (targetDate?: Date | string, format?: string) => {
      if (!targetDate ) {
        return targetDate;
      } else if (targetDate instanceof Date && Number.isNaN(targetDate.getTime())) {
        return '';
      }
      const pattern = format ?? 'YYYY-MM-DD';
      const expressions : Record<string, string> = {
        'YYYY': '[1-2]\\d{3}',
        'MM': '[0-1][1-9]',
        'DD': '[0-3][1-9]',
      }
      const regex = new RegExp(pattern.replace(/YYYY|MM|DD/g, match => expressions[match]));
      function getResult(year: string, month : string, day: string ) {
        const replacements : Record<string, string> = {
          'YYYY': year,
          'MM': month,
          'DD': day,
        }
        return pattern.replace(/YYYY|MM|DD/g, match => replacements[match]);
      }
      if (targetDate instanceof Date) {
        const year = String(targetDate.getFullYear());
        const month = String(targetDate.getMonth() + 1).padStart(2, '0');
        const day = String(targetDate.getDate()).padStart(2, '0');
        return getResult(year, month, day);
      }
      const dateString =  (targetDate??'').replace(/\D/gi, "").slice(0, 8); //숫자만 자름
      if (!regex.test(dateString)) {
        const year = dateString.slice(0,4);
        const month = dateString.slice(4,6);
        const day = dateString.slice(6,8);
        return getResult(year, month, day );
      } else {
        return targetDate;
      }
    }
  },

  /**
     * 파일 URL을 얻습니다.
     * @param fileIdOrPath 공통파일 ID 혹은 경로
     * @param isCdnStore 파일의 위치 - cdn에 저장되었다면 true
     * @returns 
     */
  getFileFullUrl: (fileIdOrPath:string, isCdnStore?:boolean) => {

    // HCON 방어로직 추가
    if(!fileIdOrPath) {
      return new URL(`../assets/images/pc/sub-hcon/no-image.png`, import.meta.url).href; // no-image 디자인
    }
    
    const runCfg          = useRuntimeConfig();
    const getFileIdToPath = (fileIdHash:string) => {
      const idLen	= fileIdHash.length;
      let		rv	= '';
      for (var i=7; i<idLen; i+=3) {
        if (i+3 >= idLen) {
          rv += fileIdHash.substring(i);
        } else {
          rv += (fileIdHash.substring(i, i+3) + '/');
        }
      }
      rv += '/' + fileIdHash;
      return rv;	
    }
    const contentsUrlPrefix = useRuntimeConfig().public.hcon.cdn.contentsBase;
    let   rv                = fileIdOrPath;
    let   store             = isCdnStore ? 'LEGACY' : 'STATIC';

    const fileIdMatch = /^(([^\/]+)\/(\d{8})\/)?(([TPOC])(\d{6})[0-9a-fA-F]{32})$/.exec(fileIdOrPath);
    if (fileIdMatch !== null) {
      switch(fileIdMatch[5]) {
        case 'T':
          store = 'TEMPORARY';
          break;
        case 'P':
          store = 'PRIVATE';
          break;
        case 'O':
          store = 'PUBLIC';
          rv = '/public/' + fileIdMatch[1] + fileIdMatch[4].substring(0, 4) + '/' + fileIdMatch[4].substring(4, 7) + '/' + getFileIdToPath(fileIdMatch[4]);
          break;
        case 'C':
          store = 'CONTENTS';
          rv = '/contents/' + fileIdMatch[1] + fileIdMatch[4].substring(0, 4) + '/' + fileIdMatch[4].substring(4, 7) + '/' + getFileIdToPath(fileIdMatch[4]);
          break;
      }
    } else if (/^withd\/[^\/]+\/[0-9a-fA-F]{64}\/[0-9a-fA-F\/]{85}\/.+\.\d{13}\.\d{10}$/.exec(fileIdOrPath)) {
      store = 'CONTENTS';
      rv = '/contents/' + fileIdOrPath;
    } else if (store != 'STATIC') {
      store = 'LEGACY';
    }

    switch(store) {
      case 'TEMPORARY':
      case 'PRIVATE':
        rv = `${runCfg.public.hcon.api.baseUrl}/api/v1/common/files/${rv}`;
        break;
      case 'LEGACY':
        if (!rv.startsWith('/')) {
          rv = '/' + rv;
        }

        if (!rv.startsWith('/ezwel-image/')) {
          rv = '/ezwel-image/' + (rv.startsWith('/') ? rv.substring(1) : rv);
        }
        
        rv = contentsUrlPrefix + rv;
        break;
      case 'PUBLIC':
      case 'CONTENTS':
        rv = contentsUrlPrefix + rv;
        break;
      case 'STATIC':
      default:
        if (cu.isNotEmpty(contentsUrlPrefix)) {
          if (rv.charAt(0) == '/') {
            rv = contentsUrlPrefix + rv;
          } else {
            rv = contentsUrlPrefix + '/' + rv;
          }
        }
        break;
    }
    return rv;    
  },  
  /**
   * 가능하면 숫자로 바꾸고 그렇지 못하면 undefined를 반환합니다.
   * @param inp 
   * @returns 
   */
  toNumber: (inp: number | string | undefined) => {
    if (inp === undefined) {
      return undefined;
    } else if (typeof(inp) == 'string') {
      const rv = parseInt(inp);
      return isNaN(rv) ? undefined : rv;
    } else {
      return inp;
    }
  },
}
